module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Create Group</h1>\n\n<form>\n\n<div class="grid-container">\n    <label for="popup_group_type" class="grid-20">\n        Group Type\n    </label>\n    <select id="popup_group_type" class="grid-50 group-type textfield">\n        <option value="other">User Defined</option>\n        <option value="school_name">School Name</option>\n        <option value="school_reg">Reg</option>\n        <option value="school_year">Year</option>\n        <option value="school_class">Class</option>\n    </select>\n</div>\n\n<br/><br/>\n\n<div class="grid-container">\n    <label for="popup_group_name" class="grid-20">\n        Group Name\n    </label>\n\n    <!-- ugly override because textfield is silly -->\n    <input type="text" id="popup_group_name" style="width:50%"\n        class="textfield group-name grid-50" />\n</div>\n\n<br/><br/>\n\n<button type="submit" class="button button-send">Send</button>\n<a class="button button-secondary button-close">Abandon</a>\n\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/new_group.html
// module id = 347
// module chunks = 0